import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

const ProjectImageViewer = ({ photos, initialIndex = 0, onClose }) => {
  const dialogRef = useRef(null);
  const [index, setIndex] = useState(initialIndex);
  const photo = photos[index];
  const move = (direction) => setIndex((current) => (current + direction + photos.length) % photos.length);

  useEffect(() => {
    const dialog = dialogRef.current;
    const trigger = document.activeElement;
    const overflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    dialog.showModal();
    return () => {
      dialog.close();
      document.body.style.overflow = overflow;
      trigger?.focus();
    };
  }, []);

  return createPortal(
    <dialog
      ref={dialogRef}
      className="project-image-viewer"
      aria-label="Project photo viewer"
      onCancel={(event) => { event.preventDefault(); onClose(); }}
      onClick={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
      onKeyDown={(event) => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          move(event.key === 'ArrowLeft' ? -1 : 1);
        }
      }}
      data-no-page-swipe
    >
      <div className="project-image-viewer__toolbar">
        <span aria-live="polite">{index + 1} / {photos.length}</span>
        <div>
          {photos.length > 1 && (
            <>
              <button type="button" aria-label="Previous image" onClick={() => move(-1)}>‹</button>
              <button type="button" aria-label="Next image" onClick={() => move(1)}>›</button>
            </>
          )}
          <button type="button" aria-label="Close image viewer" onClick={onClose}>×</button>
        </div>
      </div>
      <img src={photo.src} alt={photo.alt} decoding="async" />
    </dialog>,
    document.body
  );
};

export default ProjectImageViewer;
